/// <reference types="google.accounts" />
import GoogleAccessToken from './GoogleAccessToken';
import googleAccessTokenStore from './googleAccessTokenStore';

class GoogleTokenResponseError extends Error {}

const getGoogleAccessToken = (): Promise<GoogleAccessToken> => {
  return new Promise((resolve, reject): void => {
    const accessToken = googleAccessTokenStore.getAccessToken();

    if (accessToken !== null && !accessToken.isExpired()) {
      resolve(accessToken);

      return;
    }

    const tokenClient = google.accounts.oauth2.initTokenClient({
      client_id: import.meta.env.VITE_GOOGLE_OAUTH_CLIENT_ID,
      scope: 'openid profile email https://www.googleapis.com/auth/drive.file',
      callback: (tokenResponse: google.accounts.oauth2.TokenResponse): void => {
        if (typeof tokenResponse.error !== 'undefined') {
          reject(new GoogleTokenResponseError(tokenResponse.error));

          return;
        }

        const accessToken = new GoogleAccessToken(tokenResponse.access_token);

        googleAccessTokenStore.setAccessToken(accessToken);

        resolve(accessToken);
      },
      error_callback: (error: Error): void => {
        reject(error);
      },
    });

    tokenClient.requestAccessToken();
  });
};

export default getGoogleAccessToken;
